// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OPGSD","headerLeft":"Header_headerLeft__V+2Hz","logoLink":"Header_logoLink__phNry","logo":"Header_logo__04L6z","headerRight":"Header_headerRight__97V1G"};